(function($) {
	// Encapsulated AJAX function
	$.api = function(action, data) {
		var deferred = $.Deferred();
		
		data['action'] = action;
		
		var args = {
			method: 'POST',
			url: ajax_object.ajax_url,
			dataType: 'json',
			data: data
		};
		
		var ajax = $.ajax(args).done(function(resp) {
			switch (resp.status) {
				case 'success':
					deferred.resolve(resp);
					break;
				case 'fail':
				case 'error':
					deferred.reject(ajax, 'applicationerror', resp);
					break;
			}
		});
		
		return deferred.promise();
	};


	// HOMEPAGE CAROUSEL
	var heroCarouselSection = $(".block-hero-carousel");

	if (heroCarouselSection.length) {

		var heroCarousel = heroCarouselSection.find(".hero-carousel");

		heroCarousel.slick({
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 7000,
		});

		$('[data-slide]').click(function(e) {
			e.preventDefault();
			$('[data-slide]').removeClass("active");
			$(this).addClass("active");
			var slideIndex = $(this).data('slide');
			heroCarousel.slick('slickGoTo', slideIndex - 1);
		});

		heroCarousel.on('afterChange', function(currentSlide){
			$('[data-slide]').removeClass("active");
			$('[data-slide="' + (parseInt($('.slick-current').attr("data-slick-index")) + 1) + '"').addClass("active");
			console.log(currentSlide);
		});
	}
	
	var $tabs = $('.modal-tabs li');
	var $tabLinks = $tabs.find('a');
	var $tabContent = $('.modal-tab-content');
	$tabLinks.click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);

		$tabs.removeClass('active');
		$this.parent().addClass('active');
		$tabContent.removeClass('active');

		var contentId = $this.attr('href');
		var $content = $(contentId);

		$content.addClass('active');
	});

	// If hash on load is "log-in", open log in modal
	if (location.hash === "#log-in") {
		$('#log-in').modal('show');
	} else if (location.hash === "#log-in-ambassadors") {
		$('#log-in').modal('show');
		$('#log-in a[href="#ambassadors"]').click();
	}



	$('.scroll-next-section').each(function() {
		var $link = $(this);
		var $block = $link.closest('.block');
		var $nextSection = $block.next('.block');

		var nextId = $nextSection.attr('id');
		$link.attr('href', '#' + nextId);
	});


	function smoothScrollingTo(target) {
		if (!target) return;

		var $target = $(target);

		// Return out if the component doesn't exist
		if ($target.length === 0) return;

		// Return out if this is a modal link
		if ($target.hasClass('modal')) return;

		// Return out if this has a parent of "carousel" as we don't want to scroll
		if ($target.closest('.carousel').length > 0) return;

		// Measure the header
		var headHeight = $('.site-header').outerHeight();

		$("html,body").animate({
			scrollTop: $target.offset().top - headHeight
		}, 500);
	}


	// If this is the home page, transform any anchors starting with "/"
	if (location.pathname === "/") {
		$("a[href^='/#']").each(function() {
			var href = $(this).attr('href');
			$(this).attr('href', href.substr(1));
		})
	}

	$("a[href^='#']").filter(':not(.panel-heading a,.tab a,.modal-tabs a)').on('click', function(e) {
		e.preventDefault();
		smoothScrollingTo(this.hash);
	});

	$(document).ready(function() {
		if (!location.hash) return;

		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		smoothScrollingTo(location.hash);
	});




	// Automatically change all currency dropdowns when the one is changed (but don't change it if the user has changed it!)
	(function() {
		var $currencySelectors = $('.currency-selector select');

		// Exit out if there's not multiple currency selectors on this page
		if ($currencySelectors.length < 2) return;

		$currencySelectors.on('change', function() {
			// On change, mark this dropdown as dirty
			$(this).addClass('dirty');

			// Change other values that haven't been changed by the user
			var val = $(this).val();
			$currencySelectors.filter(':not(.dirty)').val(val);
		});
	}());

	
	
	// Toggle class of active on search container parent
	$('.mem-search-input').on('focus', function() {
		$(this).closest('.mem-search-input-container').addClass('focus');
	}).on('blur', function() {
		$(this).closest('.mem-search-input-container').removeClass('focus');
	});
	
	
	function searchMemberID() {
		var val = $('.mem-search-input').val();
		
		// Remove any errors
		$('.mem-search-error').remove();

		// Add loading class to container
		var $search_bg = $('.mem-search-bg');
		$search_bg.addClass('loading');
		
		$.api('search_member_id', {
			id: val
		}).done(function(resp) {
			// If redirect is defined...
			if (resp.redirect) {
				// ... and this is a relative URL
				if (resp.redirect.substr(0,1) === "/") {
					window.location = resp.redirect;
					return;
				}
				
				// ... or make it relative
				try {
					var url = new URL(resp.redirect);
					window.location = url.pathname;
					return;
				} catch(e) {
					// TODO: Error parsing URL
				}
			}
		}).fail(function(xhr, status, error) {
			if (status === "applicationerror") {
				// Create error message
				var $error = $('<div class="mem-search-error" />');
				$error.text(error.message);
				
				// Close btn
				var $close = $('<button class="mem-search-error-close">&times;</button>');
				$error.append($close);
				$close.click(function(e) {
					e.preventDefault();
					$error.remove();
				});
				
				// Append error
				$('.mem-search-container').append($error);
			}
			
			// TODO: Handle other errors
		}).always(function() {
			$search_bg.removeClass('loading');
		});
	}

	// Search functionality
	$('.mem-search-input').on('keydown', function(e) {
			if (e.key === "Enter") {
				e.preventDefault();
				e.stopPropagation();
			}
	}).on('keyup', function(e) {
		// On enter, submit member ID
		if (e.key === "Enter") {
			e.preventDefault();
			searchMemberID();
		}
	}).on('paste', function(e) {
		e.preventDefault();
		
		var text = e.originalEvent.clipboardData.getData('text');
		
		// Trim text
		$(this).val(text.replace(/\s/g, ''));
	});
	
	$('.mem-search-btn').click(function(e) {
		e.preventDefault();
		searchMemberID();
	});
	
	
	// Focus class on custom selects
	$('.custom-select select').focus(function() {
		$(this).parent().addClass('focus');
	}).blur(function() {
		$(this).parent().removeClass('focus');
	});
	
	// Make the sign-up instructions container same height as content
	var $instructions = $('.sign-up-instructions-container');
	if ($instructions.length) {
		var fitInstructions = function() { 
			$instructions.each(function() {
				if ($(this).hasClass('hide')) return;
				
				var $content = $(this).find('.sign-up-instructions');
				$content.css('height', '');
				$(this).css('height', $content.height());
			});
		};
		fitInstructions();
		$(window).on('resize', function() {
			fitInstructions();
		});
	}


	$('.sign-up-instructions-close').click(function() {
		$(this).closest('.sign-up-instructions-container').remove();
	});
	
	
	// Fixed header
	var $header = $('.site-header');
	var lastPos = 0;
	var $body = $('body');
	var $breadcrumbs = $('.secondary-nav');
	
	var onScroll = function() {
		var scrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
		
		var scrollingUp = lastPos > scrollPos;
		
		$header.add($breadcrumbs).toggleClass('fixed', scrollPos > 127);
		$body.toggleClass('scroll-up', scrollingUp).toggleClass('scroll-down', !scrollingUp);
		lastPos = scrollPos;
	};
	$(window).on('scroll', onScroll);
	onScroll(); // Run on init, in case the user scrolled down and refreshed	
	
	
	
	$('.faqs-container, .profile-faq-container').on('show.bs.collapse', function(e) {
		$(e.target).closest('.faq-panel').addClass('active');
	}).on('hide.bs.collapse', function(e) {
		$(e.target).closest('.faq-panel').removeClass('active');
	});
	
	// disable mousewheel on a input number field when in focus
	// (to prevent Cromium browsers change the value when scrolling)
	$('form').on('focus', 'input[type=number]', function() {
		$(this).on('mousewheel.disableScroll', function(e) {
			e.preventDefault();
		});
	}).on('blur', 'input[type=number]', function() {
		$(this).off('mousewheel.disableScroll');
	});
	
	
	
	$('.acf-field :input').focus(function() {
		$(this).closest('.acf-field').addClass('focus');
	}).blur(function() {
		$(this).closest('.acf-field').removeClass('focus');
	});
	
	
	// ACF Inline validation
	var validatable = ['text', 'number', 'tel', 'iprac', 'email', 'date', 'select', 'radio', 'url'];
	
	var validatableSelectors = [];
	for (var vi = 0;vi < validatable.length;vi++) {
		validatableSelectors.push(".acf-field-" + validatable[vi]);
	}
	var vSel = validatableSelectors.join(',');
	var $toValidate = $(vSel).filter(":not(.acf-hide-validation-icon)");
	
	$toValidate.each(function(i, elm) {
		var $elm = $(elm);
		
		var required = $(elm).attr('data-required') == "1";
		
		var type = $elm.attr('data-type');
		
		// Return out if this doesn't need to be validated  
		if (type !== "url" && !required) return;
		
		var $icon = $(this).find('.form-validation-icon');
		
		var updateUI = function(valid) {
			if (valid) {
				$icon.addClass('valid').removeClass('error');
			} else {
				$icon.addClass('error').removeClass('valid');
			}
		};
		
		var $input;
		if (type === "date") {
			$input = $(this).find('.acf-date-input');
		} else if (type === "url") {
			$input = $(this).find('input');
			
			$input.on('blur', function() {
				var val = this.value;
				
				// If this is not required and is empty, it's valid
				if (!required && val === "") {
					updateUI(true);
					return;
				}
				
				// If there's no HTTP, add it on
				if (val.match(/^https?:\/\//) === null) {
					val = 'http://' + val;
					this.value = val;
				}
				
				var error = false;
				try {
					new URL(val);
				} catch (e) {
					error = true;
				}
				
				updateUI(!error);
			});
			
		} else if (type === "radio") {
			$input = $(this).find('input[type=radio]');
			$input.on('click', function() {
				updateUI(true);
			});
		} else if (type === "email") {
			$input = $(this).find('input[type=email]');
			$input.blur(function(e) {
				var components = this.value.split("@");
				if (components.length != 2) {
					updateUI(false);
					return;
				}
				
				var domainComponents = components[1].split('.');
				if (domainComponents >= 2) {
					updateUI(false);
					return;
				}
				
				updateUI(true);
			});
		} else if (type === "tel") {
			$input = $(this).find('input[type=tel]');
			$input.blur(function() {
				var tel = this.value;
				
				// Allow only 0-9, spaces, -, (, ), +
				var match = tel.match(/^[\d\-\(\)\+\s]+$/);
				updateUI(match !== null);
			});
		} else if (type === "iprac") {
			$input = $(this).find('input[type=text]');
			$input.blur(function() {
				updateUI(null !==  this.value.match(/^IP\d{2}\-\d{5}$/i));
			});
		} else {
			$input = $(this).find('select,input');
			$input.on('change blur', function() {
				updateUI(!!this.value);
			});
		}
	});
	
	
	
	$('.acf-field-info-btn').each(function(e) {
		var $info = $(this).siblings('.acf-field-info');
		$(this).click(function(e) {
			e.preventDefault();
			e.stopPropagation();
			$info.toggleClass('active');
		});
	});
	
	var $infos = $('.acf-field-info');
	if ($infos.length > 0) {
		$('body').click(function() {
			$infos.removeClass('active');
		});
		$infos.click(function(e) {
			e.stopPropagation();
		});
	}
	

	$('.acf-image-uploader').each(function() {
		var $container = $(this);
		var $file = $container.find('input[type=file]');
		var $remove = $container.find('.show-if-value > .acf-actions > a');
		
		
		$remove.click(function() {
			$file.val("");
			$container.find('.image-preview').remove();
		});
		
		$file.on('change', function(e) {
			var $parent = $(this).closest('.acf-image-uploader');

			if (!e.target.files) return;

			var f = e.target.files[0];

			if (!f.type.match('image.*')) return;

			var reader = new FileReader();

			// Closure to capture the file information.
			reader.onload = (function(theFile) {
				return function(e) {
					var $img = $parent.find('.show-if-value>img')

					$img.on('load', function() {
						$img.off('load');
						var w = this.naturalWidth;
						var h = this.naturalHeight;

						var shortest = Math.min(w,h);

						var canv = document.createElement('canvas');
						canv.className = "image-preview";
						canv.setAttribute('width', 112);
						canv.setAttribute('height', 112);

						var ctx = canv.getContext('2d');
						ctx.drawImage(this, 0, 0, shortest, shortest, 0, 0, 112, 112);

						ctx.globalCompositeOperation = "destination-atop";
						ctx.fillStyle = "#FFF";
						ctx.arc(56, 56, 56, 0, Math.PI * 2, true);
						ctx.fill();


						$(canv).insertAfter($img);
						$img.hide();
						$parent.addClass('has-value');
					});

					$img.attr('src', e.target.result);
				};
			})(f);

			reader.readAsDataURL(f);
		});
	});

	// Preventing widows
	// $('p').each(function() {
	// 	var string = $(this).html();
	// 	string = string.replace(/ ([^ ]*)$/g, '&nbsp;$1');
	// 	$(this).html(string);
	// });

	if (window.acf) {
		var accordions = [];
		acf.addAction('new_field', function(field) {

			acf.setPreference('this.accordions', [1]); 

			switch (field.data.type) {
				case 'accordion':
					accordions.push(field.$el);

					// Add "edit" button alongside accordions
					/*
						var $edit = $('<button class="btn btn-default btn-xs acf-accordion-edit-btn">Edit</button>');
						field.$el.find('> .acf-label label').append($edit);
						break;
					*/
			}
		});

		acf.addAction('load', function() {
			// Accordion functions (copied from acf-input.js)

			// 19/07/23 DB: Disabling this functionality
			/*
			var open = function($el) {
				// open
				$el.find('.acf-accordion-content:first').slideDown().css('display', 'block');
				$el.addClass('-open');
			};
			
			var close = function($el) {
				// close
				$el.find('.acf-accordion-content:first').slideUp();
				$el.removeClass('-open');
			};

			
				// Loop accordions and add "next" button, but not to the last one
				for (var i = 0; i < accordions.length-1; i++) {
					(function($accord, index) {
						var $btn = $('<button class="acf-accordion-next-btn btn btn-primary">Next</button>');
						$accord.find('> .acf-input').append($btn);

						$btn.click(function(e) {
							e.preventDefault();

							// Find current open accordion
							close($accord);

							// Find next
							if (index+1 <= accordions.length) {
								open(accordions[index+1]);
							}
						});
					})(accordions[i], i);
				}
			*/
		});
	}


	
	$('#mc-embedded-subscribe-form').on('submit', function(e) {
		$('.mc-error').remove();
		var $optIn = $('#mce-OPT_IN');
		if (!$optIn.is(':checked')) {
			e.preventDefault();
			$('<div class="mc-error">You must consent to recieving emails to be able to join our mailing list</div>').insertAfter($optIn.parent());
			return false;
		}
	});

	// Add error icon
	if (typeof acf !== "undefined") {
		acf.addAction('invalid_field', function(field) {
			field.$el.find('.form-validation-icon').addClass('error');
		});
	}


	// Add back button to form
	$('.step-2 .acf-form-submit').each(function() {
		// Create back button
		var $btn = $('<a href="?back=1" class="btn btn-outline btn-blue">Back</a>');
		$(this).prepend($btn);
	});

	var $stepCarousel = $('#step-carousel');
	if ($stepCarousel.length) {
		var slideCount = $stepCarousel.find('.carousel-inner .item').length;

		var $leftArrow = $stepCarousel.find('.carousel-arrow.left');
		var $rightArrow = $stepCarousel.find('.carousel-arrow.right');

		$stepCarousel.on('slide.bs.carousel', function (e) {
			var index = $(e.relatedTarget).index();

			$rightArrow.toggleClass('disabled', index === slideCount-1);
			$leftArrow.toggleClass('disabled', index === 0);
		});
	}

	// FIXED BOTTOM RIGHT HAND CORNER POPUP



	var fixedPopup = document.querySelector(".fixed-popup");

	if (fixedPopup !== null) {

		var fixedPopupClose = fixedPopup.querySelector(".fixed-popup__close");

		fixedPopupClose.addEventListener('click', function () {
			fixedPopup.classList.remove("active");
			Cookies.set('popup_dismissed', 'true');
		});

		var getPopupCookie = Cookies.get('popup_dismissed');

		if (getPopupCookie != 'true') {
			setTimeout(function(){ 
				fixedPopup.classList.add("active");
			}, 3000);
		}
	}


	(function() {
		$('.carousel-eq-height').each(function() {
			var items = $(this).find('.item'), //grab all slides
			heights = [], //create empty array to store height values
			tallest; //create variable to make note of the tallest slide

			if (items.length) {
				function normalizeHeights() {
					items.each(function() { //add heights to array
						heights.push($(this).height());
					});
					tallest = Math.max.apply(null, heights); //cache largest value
					items.each(function() {
						$(this).css('min-height',tallest + 'px');
					});
				}
				normalizeHeights();

				$(window).on('resize orientationchange', function () {
					tallest = 0, heights.length = 0; //reset vars
					items.each(function() {
						$(this).css('min-height','0'); //reset min-height
					});
					normalizeHeights(); //run it again
				});
			}
		});
	})();

	var stepSlider = document.querySelector(".step-slider");

	if (stepSlider !== null) {
		$('.step-slider').slick({
			slidesToShow: 4.5,
			slidesToScroll: 1,
			infinite: false,
			prevArrow: '#steps-left',
			nextArrow: '#steps-right',
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 4.5,
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToShow: 2.5,
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1.5,
					slidesToScroll: 1
				  }
				}
			]
		});
	}
	var scoresSlider = document.querySelector(".scores-slider");

	if (scoresSlider !== null) {
		$('.scores-slider').slick({
			slidesToShow: 3.25,
			slidesToScroll: 1,
			infinite: false,
			prevArrow: '#scores-left',
			nextArrow: '#scores-right',
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 3.25,
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToShow: 2.5,
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1.25,
					slidesToScroll: 1
				  }
				}
			]
		});
	}
})(jQuery);